import questions from './questions';

export const controlTreeNodeTypes = {
  BUSINESS: 'business',
  INDIVIDUAL: 'individual',
} as const;

export const controlTreeControlFields = {
  CAPITAL_SHARE: 'capitalShare',
  VOTING_SHARE: 'votingShare',
  OTHER_CONTROL: 'otherControl',
} as const;

export type ControlTreeControlField = typeof controlTreeControlFields[
  keyof typeof controlTreeControlFields
];

export const defaultControlTreeBusinessFields = [
  questions.Q_COMPANY_NAME,
  questions.Q_ORG_NUMBER,
  questions.Q_ADDRESS,
  questions.Q_CITY,
  questions.Q_POSTAL_CODE,
  questions.Q_RESIDENCE,
];

export const defaultControlTreeIndividualFields = [
  questions.Q_FIRST_NAME,
  questions.Q_LAST_NAME,
  questions.Q_DATE_OF_BIRTH,
  questions.Q_ADDRESS,
  questions.Q_CITY,
  questions.Q_POSTAL_CODE,
  questions.Q_RESIDENCE,
  questions.Q_NATIONAL_IDENTIFIER,
  questions.Q_CITIZENSHIP,
  questions.Q_TAX_RESIDENCY,
  questions.Q_PEP,
];

export const controlTreeControlFieldList: ControlTreeControlField[] = [
  controlTreeControlFields.CAPITAL_SHARE,
  controlTreeControlFields.VOTING_SHARE,
  controlTreeControlFields.OTHER_CONTROL,
];

export type ControlTreeNode = {
  id: string;
  parentId?: string;
  type: typeof controlTreeNodeTypes[keyof typeof controlTreeNodeTypes];
  control?: Partial<Record<ControlTreeControlField, number | string>> & {
    custom?: Record<string, unknown>;
  };
  companyName?: string;
  firstName?: string;
  lastName?: string;
  [field: string]: unknown;
};
